import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AddpartyComponent } from '../addparty/addparty.component';

@Component({
  selector: 'app-viewparty',
  templateUrl: './viewparty.component.html',
  styleUrls: ['./viewparty.component.css']
})
export class ViewpartyComponent implements OnInit {

  //terms Values
  isaddterms: boolean = false;
  iseditterms: boolean = false;
  isdeleteterms: boolean = false;
  isviewterms: boolean = false;

  countryColl: any = [];
  localityColl: any = [];
  //Save Validation
  submitted: boolean;
  successfully: boolean;

  companyColl: any = [];
  aBO: any = [];
  //Edit Get Values
  partyColl: any = [];
  partyid: number = 0

  paymenttermsColl: any = [];

  partyform = new FormGroup({
    partyid: new FormControl(null),
    partyname: new FormControl('', Validators.required),
    mobileno: new FormControl('', Validators.required),
    address1: new FormControl(''),
    address2: new FormControl(''),
    address3: new FormControl(''),
    landmark: new FormControl(''),
    localityid: new FormControl(null, Validators.required),
    ptype: new FormControl(''),
    inactive: new FormControl(false),
  });

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;
  formname: String = "";
  ptype: String = "";

  constructor(private appService: DhukanDataService, private route: ActivatedRoute, private productFindService: NgbModal,
    public router: Router, private toastr: ToastrService, public loginService: LoginDataService) {
    this.route.queryParams.subscribe(params => {
      if (params.id !== undefined) {
        this.partyid = params.id
      }
      if (params.ptype !== undefined) {
        this.ptype = params.ptype
      }

      if (this.ptype === "C") {
        this.formname = "Customer"
      }
      else if (this.ptype === "S") {
        this.formname = "Supplier"
      }
    });
    this.fnServiceChanges();
  }


  fnServiceChanges() {
    this.loginService.serviceloginChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        if (this.loginService.fnCheckUser()) {

          if (this.fnCheckUserPririvilage()) {
            this.isloading = true;
            this.fnOnInitForm();
          }
          else {
            this.fnUserFailedForm();
          }

        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }
    });
  }

  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        if (this.loginService.fnCheckUser()) {
          if (this.fnCheckUserPririvilage()) {
            this.isloading = true;
            this.fnOnInitForm();
          }
          else {
            this.fnUserFailedForm();
          }
        }
        else {
          this.loginService.fnGetUserRoleList();
        }
      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.isaddterms = true;
      this.partyform.reset();
      this.fnInitializePartyFormGroup();

      if (this.partyid > 0) {
        this.fngetParty();
      }



    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }



  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.partyid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }

    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }


  fnInitializePartyFormGroup() {
    this.partyform.setValue({
      partyid: 0,
      partyname: '',
      mobileno: '',
      address1: '',
      address2: '',
      address3: '',
      landmark: '',
      localityid: null,
      ptype: this.ptype,
      inactive: false,
    })
  }

  //Get 
  fngetLocality() {
    var data = {
      'localityid': 0,

    }
    this.appService.getLocality(data)
      .subscribe(
        (res) => {
          //console.log(res)
          this.localityColl = res.json().result;
          //console.log(this.localityColl)
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  //Get 
  fngetParty() {
    var data = {
      'partyid': this.partyid,
      'ptype':this.ptype,
      'companyid': this.loginService.fnGetCompanyId()          
    }
    this.appService.getParty(data)
      .subscribe(
        (res) => {
          this.partyColl = res.json().result;
          var editdata = this.partyColl[0];
          this.aBO = editdata;
          //console.log(this.aBO)
          this.fnEditterms(editdata);
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }





  //Save Btn Click
  fnSaveBtnClick() {
    try {
      this.submitted = true;
      this.successfully = false;
      //Validate
      if (this.partyform.valid) {
        //Check
        var data = {
          'partyid': this.partyid,
          'partyname': this.partyform.get('partyname').value,
          'mobileno': this.partyform.get('mobileno').value,
          'address1': this.partyform.get('address1').value,
          'address2': this.partyform.get('address2').value,
          'address3': this.partyform.get('address3').value,
          'landmark': this.partyform.get('landmark').value,
          'localityid': this.partyform.get('localityid').value,
          'ptype': this.partyform.get('ptype').value,
          'inactive': this.partyform.get('inactive').value,
          'companyid': this.loginService.fnGetCompanyId(),
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
        }
        this.appService.fnCheckParty(data).subscribe(
          (res) => {
            var _checkresult = res.json().result[0].checkfield;

            if (_checkresult === "done") {
              if (this.partyform.get('partyid').value > 0) {
                //Update Department
                this.fnSetParty(data);
              }
              else {
                //Insert Department
                this.fnInsertParty(data);
              }
            }
            else {
              if (_checkresult === "name") {
                this.partyform.controls['partyname'].setErrors({ 'notfound': true });
              }
            }
          },
          (err) => {
            this.toastr.error('Error', err);
          });
      }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  //Insert
  fnInsertParty(data) {

    this.appService.fnInsertParty(data).subscribe(
      (res) => {
        if (res.json().result != "") {
          this.toastr.success('', "The new Party has been added successfully.Insert Successfully");

          this.fnInsertActivityLog('INSERT', 0, data.partyid);

          this.fnCloseParty();
        }
      },
      (err) => {
        this.toastr.error('Error', err);
      });

  }

  //Set
  fnSetParty(data) {

    this.appService.fnSetParty(data).subscribe(
      (res) => {
        if (res.json().result != "") {
          this.toastr.success('', "The Party has been updated successfully.");

          this.fnInsertActivityLog('EDIT', this.partyid, data.partyname);

          this.fnCloseParty();
        }
      },
      (err) => {
        this.toastr.error('Error', err);
      });

  }

  //Close
  fnCloseParty() {
    try {
      let navigationExtras: NavigationExtras = {
        queryParams: {
          'ptype': this.ptype,
        }
      }

      this.router.navigate(['/Party'], navigationExtras);


    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  fnEditParty() {
    try {
      var deptid = this.partyid

      const modalRef = this.productFindService.open(AddpartyComponent, { size: <any>'l', backdrop: 'static', keyboard: false });
      modalRef.componentInstance.partyid = deptid;
      modalRef.componentInstance.ptype = this.ptype
      if (modalRef.componentInstance.ptype === 'C') {
        modalRef.componentInstance.formname = 'Customer'
      }
      else if (modalRef.componentInstance.ptype === 'S') {
        modalRef.componentInstance.formname = 'Supplier'
      }
      modalRef.componentInstance.ngOnInit();
      modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

        this.fngetParty();

      });

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnEditBtnClick() {
    this.iseditterms = true;
    this.isviewterms = false;

  }
  private fnEditterms(deptBO) {

    this.partyform.setValue({
      partyid: deptBO.partyid,
      partyname: deptBO.partyname,
      mobileno: deptBO.mobileno,
      address1: deptBO.address1,
      address2: deptBO.address2,
      address3: deptBO.address3,
      landmark: deptBO.landmark,
      localityid: deptBO.localityid,
      ptype: deptBO.ptype,
      inactive: deptBO.inactive,
    });

    this.isaddterms = false;
    this.iseditterms = true;
    this.isdeleteterms = false;
    this.isviewterms = true;
  }
  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
        'companyid': this.loginService.fnGetCompanyId()
      }


      // this.appService.fnInsertActivity(data).subscribe(
      //   (res)=>{
      //   },
      //   (err)=>{

      //   });

    } catch {

    }
  }



  private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  }

  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }





}
